// todo src/Pages/phone-numbers/paths.ts aslso has
//  brandBusinessProfiles: "/business-profiles",
//  and
//  brandBrandedPhoneNumbers: "/branded-phone-numbers",

export const AdminPaths = {
    brands: "brands",
    newBrand: "new",
    editBrand: ":id",
    brandDetails: "details",
    brandMaintenance: "maintenance",
    maintenanceBulkTaskCancellation: "bulk-task-cancellation",
    brandBacklogs: "maintenance/backlogs",
    brandBusinessProfiles: "business-profiles",
    brandBrandedPhoneNumbers: "branded-phone-numbers",
    brandCallCenterPhoneNumbers: "call-center-phone-numbers",
    voices: "voices",
    templates: "templates",
} as const;
